var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAscDecBlackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70711 5.29289C1.31658 4.90237 0.683418 4.90237 0.292894 5.29289C-0.0976311 5.68342 -0.0976311 6.31658 0.292894 6.70711L3.29289 9.70711C3.68342 10.0976 4.31658 10.0976 4.70711 9.70711L7.70711 6.70711C8.09763 6.31658 8.09763 5.68342 7.70711 5.29289C7.31658 4.90237 6.68342 4.90237 6.29289 5.29289L5 6.58579L5 1C5 0.447715 4.55229 -3.01409e-07 4 -3.49691e-07C3.44772 -3.97973e-07 3 0.447714 3 1L3 6.58579L1.70711 5.29289Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAscDecBlackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/asc-dec-black-arrow.ef799da548c253a6a84fce65e9554a94.svg";